import { Form, Input } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  id?: number
}

export const FormNomenclatureProductsCategories = ({ id }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Form.Item
        name="name"
        label={t('nomenclature.name')}
        rules={[{ required: true }]}
      >
        <Input placeholder={t('nomenclature.name')} />
      </Form.Item>

      <Form.Item
        name="code"
        label={t('nomenclature.code')}
        rules={[{ required: true }]}
      >
        <Input placeholder={t('nomenclature.code')} disabled={!!id} />
      </Form.Item>

      <Form.Item name="description" label={t('nomenclature.description')}>
        <Input.TextArea rows={4} placeholder={t('task.description')} />
      </Form.Item>
    </>
  )
}
